export default {
    registerCookie: { 
        url: 'sanctum/csrf-cookie', 
        method: 'get', 
        baseURL: process.env.VUE_APP_AUTH_URL, 
    },
    sendPromoCode: {
        url: 'auth/send/promoCode',
        method: 'post'
    },
    getMailingFirstName: {
        url: 'mailings/firstname',
        method: 'post'
    },
    getContacts: { 
        url: 'auth/contacts', 
        method: 'post', 
    },
    insertDebtor: {
        url: 'auth/insert',
        method: 'post'
    },
    login: { 
        url: 'auth/sanctum/token', 
        method: 'post',  
    },
    mailinglogin: { 
        url: 'mailings/token', 
        method: 'post',  
    },
    getUser: { 
        url: 'user/auth', 
        method: 'get', 
    },
    whatsText: { 
        url: 'whatsMessage', 
        method: 'get', 
    },
    contatoWhatsapp: {
        url: 'whatsapp',
        method: 'post',
    },
    getLinkAccess: {
        url: '/getLinkAccess',
        method: 'post',
    },
    getDirectLinkAccess: {
        // Fluxo antigo (?SApp=/?cod=, encryptedData de 2 segmentos docNumber.date).
        // NÃO trocar para v2 aqui: v2 exige um 3º segmento (UserID administrativo
        // resolvível via UspReturnUserAdm) que esse payload nunca teve — daria 400
        // "Link de acesso inválido" em todo login por esse fluxo.
        url: '/getDirectLinkAccess',
        method: 'post',
    },
    getDirectLinkAccessShortCode: {
        // DX-2201: só o link curto novo (baseURL/{codigo}) usa v2, que é quem sabe
        // resolver shortCode. Endpoint separado do getDirectLinkAccess de propósito.
        url: '/getDirectLinkAccessV2',
        method: 'post',
    }

}